import type { LocaleCode } from "@homeinstead/locale";
import type { CareGiverLeadFormData } from "~www/types/forms/care-giver-lead-form";

import {
  getInCountryDisplayName,
  getLocaleMetadata,
} from "@homeinstead/locale";

export type BooleanKeys<T> = {
  [K in keyof T]: NonNullable<T[K]> extends boolean ? K : never;
}[keyof T] &
  string;

export type StringKeys<T> = {
  [K in keyof T]: NonNullable<T[K]> extends string ? K : never;
}[keyof T] &
  string;

export const textFields: [
  StringKeys<CareGiverLeadFormData["step2"]>,
  string,
][] = [
  ["FirstName", "First Name"],
  ["LastName", "Last Name"],
  ["Email", "Email"],
];

export const getCheckboxFields = (
  localeCode: LocaleCode,
): [BooleanKeys<CareGiverLeadFormData["step2"]>, string][] => {
  const countryName = getInCountryDisplayName(
    getLocaleMetadata(localeCode).country,
  );

  // TODO: look into changing `CanWorkInUS` to `CanWorkInCountry` or the legacy name `HasDocuments`
  // https://joinhonor.atlassian.net/browse/DEX-1363
  return [
    [
      "CanWorkInUS",
      `I have documents that establish my identity and eligibility to work in ${countryName}.`,
    ],
    [
      "BusinessInEnglish",
      "I can conduct business in written and spoken English.",
    ],
    [
      "OptInSms",
      `By checking this box, I consent to receive automated SMS text messages from Home Instead at the number provided, including job opportunities and employment-related messages. Message frequency may vary. Message & data rates may apply. Reply STOP to opt out. For assistance, text "HELP." For more details, including our SMS terms, see our `,
    ],
  ];
};
